// extracted by mini-css-extract-plugin
module.exports = {"Count":"PopupCategories__Count_1HVl6"};